/*
  hs-lazy-video.js — loads below-the-fold videos only when they get close to
  the screen (2026-11-03, homepage load-time fix).

  Why: <video autoplay> downloads the WHOLE file at page load, and
  loading="lazy" is ignored on <video> by every browser — so the homepage
  was pulling ~24MB of 1080p video the moment it opened.

  Markup (see snippets/hs-lazy-video.liquid):
    <video data-hs-lazy-video data-poster="…" muted loop playsinline preload="none">
      <source data-src="…" type="video/mp4">
    </video>
  - poster + source are only set once the video is within ~1 screen;
  - it plays while on screen and pauses when it leaves (saves battery/CPU).
  Also: [data-hs-lazy-poster] — only the poster is deferred (click-to-play
  cards in "Знято вами", which have many posters off to the side).

  Checked with getBoundingClientRect on a timer + scroll, not only an
  IntersectionObserver — CLAUDE.md documents IO callbacks going missing in
  some mobile Safari cases, which would leave a video blank for good.
*/
(function () {
  if (window.HSLazyVideo) return;
  window.HSLazyVideo = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function near(el, factor) {
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return false; // hidden (display:none)
    var h = window.innerHeight, w = window.innerWidth;
    return r.top < h * (1 + factor) && r.bottom > -h * factor &&
           r.left < w * (1 + factor) && r.right > -w * factor;
  }

  function onScreen(el) { return near(el, 0); }

  function load(v) {
    if (v.dataset.hsLoaded) return;
    v.dataset.hsLoaded = '1';
    if (v.dataset.poster) v.poster = v.dataset.poster;
    v.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    v.load();
  }

  function check() {
    document.querySelectorAll('video[data-hs-lazy-video]').forEach(function (v) {
      if (near(v, 1)) load(v);
      if (!v.dataset.hsLoaded || reduceMotion) return;
      if (onScreen(v)) {
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (!v.paused) {
        v.pause();
      }
    });
    document.querySelectorAll('video[data-hs-lazy-poster]').forEach(function (v) {
      if (v.dataset.poster && near(v, 0.5)) {
        v.poster = v.dataset.poster;
        v.removeAttribute('data-hs-lazy-poster');
      }
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; check(); }, 120);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('visibilitychange', check);
  document.addEventListener('shopify:section:load', check);
  // Horizontal carousels move without page scroll — a light timer covers them.
  setInterval(check, 400);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
